import { SolanaChainTypeFromJSON, SolanaChainTypeToJSON } from './SolanaChainType.js';

/* tslint:disable */
function SimulateSVMTransactionRequestFromJSON(json) {
    return SimulateSVMTransactionRequestFromJSONTyped(json);
}
function SimulateSVMTransactionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chain': SolanaChainTypeFromJSON(json['chain']),
        'transactions': json['transactions'],
        'accountAddress': json['accountAddress'],
        'domain': json['domain'],
        'method': json['method'],
    };
}
function SimulateSVMTransactionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chain': SolanaChainTypeToJSON(value.chain),
        'transactions': value.transactions,
        'accountAddress': value.accountAddress,
        'domain': value.domain,
        'method': value.method,
    };
}

export { SimulateSVMTransactionRequestFromJSON, SimulateSVMTransactionRequestFromJSONTyped, SimulateSVMTransactionRequestToJSON };
